"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const Input = styled_components_1.default.input `
  font-family: CatV, sans-serif;
`;
const PlayerName = styled_components_1.default.span `
  font-family: CatV, sans-serif;
  color: #fa00dd;
`;
const Msg = styled_components_1.default.span `
  font-family: CatV, sans-serif;
`;
const Container = styled_components_1.default.div `
  position: absolute;
  left: 0;
  bottom: 0;
  padding: 8px;
  margin: 8px;
  background-color: white;
  border: 1px black solid;
  width: 350px;
`;
const List = styled_components_1.default.ul `
  list-style: none;
  padding-left: 0;
  max-height: 300px;
  overflow-y: scroll;
`;
const ChatUI = ({ chatHistory, sendMsg }) => {
    const [msg, setMsg] = react_1.useState("");
    const ref = react_1.useRef();
    const send = (e) => {
        e.preventDefault();
        if (msg.length === 0)
            return;
        sendMsg(msg);
        setMsg("");
    };
    react_1.useEffect(() => {
        // scroll into view whenever there's a new message
        if (ref.current) {
            const ul = ref.current;
            ul.scrollTop = ul.scrollHeight;
        }
    }, [chatHistory.length]);
    return (react_1.default.createElement(Container, null,
        react_1.default.createElement(List, { ref: ref }, [...chatHistory].map(({ sender, msg }, i) => (react_1.default.createElement("li", { key: i },
            react_1.default.createElement(PlayerName, null, sender),
            ": ",
            react_1.default.createElement(Msg, null, msg))))),
        react_1.default.createElement("form", { onSubmit: send },
            react_1.default.createElement(Input, { type: "text", placeholder: "Say 'hi'", value: msg, onChange: (e) => setMsg(e.target.value) }))));
};
exports.default = ChatUI;
//# sourceMappingURL=data:application/json;base64,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